import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
}

const LegalModal: React.FC<Props> = ({ isOpen, onClose, title, content }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[2000] flex items-center justify-center p-6">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-black/80 backdrop-blur-md"
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="relative w-full max-w-3xl max-h-[80vh] glass-card rounded-[2.5rem] border border-rose-500/20 shadow-[0_0_100px_rgba(225,29,72,0.1)] overflow-hidden flex flex-col"
          >
            <div className="p-8 border-b border-white/5 flex items-center justify-between bg-rose-500/5">
              <h2 className="text-2xl md:text-3xl font-black text-white tracking-tighter uppercase">{title}</h2>
              <button 
                onClick={onClose}
                className="p-2 rounded-full hover:bg-white/10 transition-colors text-gray-400 hover:text-white"
              >
                <X className="w-6 h-6" />
              </button>
            </div>
            
            <div className="flex-1 overflow-y-auto p-8 md:p-12 text-gray-400 space-y-8 leading-relaxed font-medium text-sm md:text-base scrollbar-thin scrollbar-thumb-rose-500">
              {content}
            </div>
            
            <div className="p-8 border-t border-white/5 bg-black/40 text-center">
              <p className="text-[10px] font-black uppercase tracking-[0.3em] text-gray-600">
                Heliophania Anamorphe Legal Department • v1.0.2025
              </p>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default LegalModal;